import React from "react";
import { Link } from "react-router-dom";

import { ProfileLink } from "app/links";
import { t, Trans } from "app/utils";

import FeedItemTitle from "components/feed/feed-item/preview/FeedItemTitle";

import getUserName from "app/utils/getUserName";
import Multiple from "./photo-created/Multiple";
import QuickLinks from "./photo-created/QuickLinks";

const Singular = ({ item, user, event }) => (
  <div>
    <Link to={`/events/${event.id}/photos`}>
      <img src={item.entity.image.largeUrl} alt={getUserName(user)} />
    </Link>
  </div>
);

const getUniqueUserCount = item => {
  // Primary User ID
  const primary = item.users[0]?.id;

  // Child User IDs
  const children = item.childUserActivities.map(
    photo => photo.entity.uploader.id
  );

  // Unique list of all users on this activity
  const userCount = Array.from(new Set([primary, ...children])).filter(id => !!id).length;

  return userCount;
};

const PhotoCreated = ({ item, onPhotoCheerToggle, onUserActivityUpdate }) => {
  // Primary User
  const user = item.users[0];
  const { event } = item.entity;

  // How many photos are in this feed item?
  const count = 1 + item.childUserActivities.length;
  const isMultiple = count >= 2;

  const users = getUniqueUserCount(item);

  return (
    <div className="FeedItem__preview__photo_created">
      <FeedItemTitle item={item} date={item.bumpedAt}>
        <QuickLinks
          event={event}
          photo={item.entity}
          isMultiple={isMultiple}
          userActivity={item}
          onUserActivityUpdate={onUserActivityUpdate}
        />
        <h3 className="FeedItem__title">
          <ProfileLink user={user} />
          {users > 1 && (
            <span>
              <Trans> and {users - 1} other user{users > 2 ? "s" : ""}</Trans>
            </span>
          )}

          {isMultiple
            ? t(` uploaded ${count} photos `)
            : t(" uploaded a photo ")}
          <span>
            to <Link to={`/events/${event.id}/photos`}>{event.name}</Link>
          </span>
        </h3>
      </FeedItemTitle>

      {!isMultiple && <Singular item={item} user={user} event={event} />}
      {isMultiple && (
        <Multiple
          item={item}
          event={event}
          onPhotoCheerToggle={onPhotoCheerToggle}
        />
      )}
    </div>
  );
};

export default PhotoCreated;
